import React from 'react';
import Header from '../sections/Header';
import Footer from '../sections/Footer';

const Layout = ({ children, hideFooter = false, mainClassName = '' }) => {
  return (
    <>
      <Header />
      <main className={`flex-grow ${mainClassName}`.trim()}>
        {children}
      </main>
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
